import Api from '@common/services/api';

export const getAccessRequestsEndpoint = (organisationId: string, channelId: string) => {
    return `/v1/organisations/${organisationId}/channels/${channelId}/access-requests`;
};

export const approveAccessRequest = async (organisationId: string, accessRequestId: string) => {
    return Api.post(`/v1/organisations/${organisationId}/channels/access-requests/${accessRequestId}/approve`);
};

export const rejectAccessRequest = async (organisationId: string, accessRequestId: string) => {
    return Api.post(`/v1/organisations/${organisationId}/channels/access-requests/${accessRequestId}/reject`);
};
